import { FILTER_OPTIONS } from "./profiles";

export const GENDER_OPTIONS = [
  { value: "Female", label: "Female (Bride)" },
  { value: "Male", label: "Male (Groom)" },
];

export const CHILDREN_OPTIONS = ["None", "1", "2", "3", "3 or more"];

export const SCHOOL_EDUCATION_OPTIONS = [
  "Secondary (10th)",
  "Senior Secondary (12th)",
  "Graduate",
  "Post Graduate",
  "Doctorate",
  "Other",
];

export const MADARSA_EDUCATION_OPTIONS = [
  "Hifz (Qur'an Memorization)",
  "Aalim / Aalimah Course",
  "Qari / Qariyah",
  "Basic Islamic Studies",
  "None / No Madarsa Education",
  "Other",
];

export const RELIGIOUS_BACKGROUNDS = ["Sunni Muslim", "Shia Muslim", "Revert Muslim"];

export const SCHOOL_OF_THOUGHT = [
  "Hanafi",
  "Shafi'i",
  "Maliki",
  "Hanbali",
  "Ahle Hadith",
  "Salafi",
  "Deobandi",
  "Tablighi Jamaat",
  "Barelvi",
  "Dawat-e-Islami",
  "Jamaat-e-Islami",
  "Other",
];

export const RELIGIOUS_PRACTICE = [
  "Practicing",
  "Moderately Practicing",
  "Less Practicing",
  "Learning / Improving",
  "Prefer Not to Say",
  "Other",
];

export const COMPLEXION = [
  "Fair",
  "Wheatish",
  "Medium",
  "Dusky",
  "Dark",
  "Prefer Not to Say",
  "Other",
];

export const DIETS = [
  "Vegetarian",
  "Non-Vegetarian",
  "Eggetarian",
  "Vegan",
  "Other",
  "Prefer Not to Say",
];

export const HABIT_FREQUENCY = ["Never", "Occasionally", "Regularly", "Prefer Not to Say"];

export const SPOKEN_LANGUAGES = [
  "English",
  "Hindi",
  "Gujarati",
  "Urdu",
  "Arabic",
  "Bengali",
  "Marathi",
  "Tamil",
  "Telugu",
  "Malayalam",
  "Kannada",
  "Punjabi",
  "Other",
];

export const FAMILY_TYPES = ["Nuclear", "Joint", "Extended"];

export const FAMILY_VALUES = ["Religious", "Traditional", "Moderate", "Liberal"];

export const PHOTO_PRIVACY = ["Public", "Registered Members", "After Contact Approval"];

export const CONTACT_METHODS = ["Phone Call", "Email", "WhatsApp"];

export const RELATIONSHIP_OPTIONS = [
  "Father",
  "Mother",
  "Brother",
  "Sister",
  "Guardian",
  "Wali",
  "Other",
];

export const PREF_MARITAL = ["Any", "Never Married", "Divorced", "Widowed"];

export const PREF_RELIGIOUS = ["Any", "Regular in salah", "Moderate", "Still growing in practice"];

export const PREF_CHILDREN = [
  "Open to a partner with children",
  "Prefer a partner without children",
  "Open to discussing",
];

export const STEPS = [
  { n: 1, key: "for", title: "Profile For" },
  { n: 2, key: "basic", title: "Basic Information" },
  { n: 3, key: "career", title: "Education & Career" },
  { n: 4, key: "religious", title: "Religious Information" },
  { n: 5, key: "lifestyle", title: "Lifestyle" },
  { n: 6, key: "family", title: "Family Information" },
  { n: 7, key: "preferences", title: "Marriage Preferences" },
  { n: 8, key: "photos", title: "Photos" },
  { n: 9, key: "contact", title: "Contact & Privacy" },
  { n: 10, key: "preview", title: "Profile Preview" },
  { n: 11, key: "submit", title: "Submit Profile" },
];

export const INITIAL_DATA = {
  profileFor: "",
  fullName: "",
  gender: "",
  dob: { day: "", month: "", year: "" },
  country: "",
  state: "",
  city: "",
  nationality: "",
  communityJamaat: "",
  communityJamaatOther: "",
  maritalStatus: "",
  children: "",
  schoolEducation: "",
  schoolEducationOther: "",
  madarsaEducation: "",
  madarsaEducationOther: "",
  profession: "",
  professionOther: "",
  income: "",
  religiousBackgrounds: [],
  schoolOfThought: [],
  schoolOfThoughtOther: "",
  religiousPractice: "",
  religiousPracticeOther: "",
  height: "",
  weight: "",
  complexion: "",
  complexionOther: "",
  diet: "",
  smoking: "",
  tobacco: "",
  alcohol: "",
  languages: [],
  languagesOther: "",
  hobbies: "",
  familyType: "",
  familyValues: "",
  fatherOccupation: "",
  motherOccupation: "",
  siblings: "",
  familyLocation: "",
  familyIntro: "",
  prefAgeFrom: "",
  prefAgeTo: "",
  prefLocations: [],
  prefMaritalStatuses: [],
  prefEducation: "",
  prefProfession: "",
  prefReligious: "",
  prefHeight: "",
  prefChildren: "",
  partnerVision: "",
  mainPhoto: null,
  mainPhotoUrl: "",
  additionalPhotos: [],
  photoPrivacy: "",
  mobile: "",
  email: "",
  whatsapp: "",
  preferredContact: "",
  waliName: "",
  waliRelationship: "",
  waliMobile: "",
  fullAddress: "",
};

export const FORM_COUNTRIES = FILTER_OPTIONS.countries;
export const FORM_EDUCATION = FILTER_OPTIONS.education;
export const FORM_PROFESSIONS = FILTER_OPTIONS.professions;
export const FORM_MARITAL = FILTER_OPTIONS.maritalStatus;

export const MARITAL_STATUS_OPTIONS = [
  "Never Married",
  "Divorced",
  "Widowed",
  "Married",
  "Married — Seeking Additional Marriage",
];

export const COMMUNITY_JAMAAT_OPTIONS = [
  "Shaikh / Sheikh",
  "Sayyid / Syed",
  "Pathan",
  "Mansuri",
  "Ansari",
  "Qureshi",
  "Momin",
  "Surati Sunni Vohra",
  "Bharuchi Vohra",
  "Bohra",
  "Khoja",
  "Memons",
  "Rangrez",
  "Julaha",
  "Saifi",
  "Sutar",
  "Darzi",
  "Malik",
  "Mughal",
  "Mir",
  "Siddiqui",
  "Farooqui",
  "Usmani",
  "Qadri",
  "Other",
];
